import React, { useEffect, useState } from "react";
import Navbar from "../sections/common/Navbar";
import Slider from "react-slick";
import "../Styles/propertydetails.css";
import { RiMapPin2Line } from "react-icons/ri";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdOutlineBed } from "react-icons/md";
import { MdOutlineBathtub } from "react-icons/md";
import { FaRegCopy } from "react-icons/fa6";
import { BsCarFront } from "react-icons/bs";
import { TbAirConditioning } from "react-icons/tb";
import { FiMapPin } from "react-icons/fi";
import Pagination from "../sections/common/Pagination";
import Faq from "../sections/common/Faq";
import Footer from "../sections/common/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { inquiryApi } from "../apis/inquiry/inquiry";
import { useDispatch, useSelector } from "react-redux";
import { fetchPropertyDetails } from "../Redux/slice/propertyDetailsSlice";
import { ErrorToaster } from "../components/Toaster";

// Custom Arrow Components
const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
};

// SliderComponent
const SliderComponent = ({ items, setMainImage }) => {
  const settings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 1500,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {items && items.property_images && items.property_images.length > 0 ? (
          items.property_images.map((image) => (
            <div key={image.id} onClick={() => setMainImage(image.image)}>
              <img src={image.image} alt={image.alt} className="slider-image" />
            </div>
          ))
        ) : (
          <p>No images available</p>
        )}
      </Slider>
    </div>
  );
};

const PropertyDetails = () => {
  const { productSlug } = useParams();
  const productId = productSlug.split("-").pop();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [mainImage, setMainImage] = useState("");
  const dispatch = useDispatch();
  const items = useSelector((state) => state?.productDetails?.data?.data);
  const related = useSelector((state) => state?.productDetails?.data?.related);

  useEffect(() => {
    dispatch(fetchPropertyDetails(productId));
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      name: name,
      email: email,
      phone: phone,
      message: message,
    };
    if (phone.length !== 10) {
      ErrorToaster("Phone number must be of 10 digits");
      return;
    }
    await inquiryApi(data, setName, setEmail, setPhone, setMessage);
  };

  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="container-fluid property-details-main-bg">
        <section className="listing-banner">
          <h1>Property Details</h1>
        </section>
        <section className="container page-location">
          <p>Home / Property Details</p>
        </section>
        <section className="property-details-title-section">
          <div className="container">
            <div className="row property-details-title-row">
              <div className="col-12 p-0">
                <div className="property-details-button">
                  <button className="sale-btn">For Sell</button>
                  <button className="sale-btn featured">Featured</button>
                </div>
              </div>
              <div className="col-12 p-0">
                <div className="property-details-top-title">
                  <h2>{items && items.title}</h2>
                  <p>Last Updated on : {items && items.updated}</p>
                </div>
              </div>
              <div className="col-12 p-0 property-details-top-location">
                <p>
                  <span>
                    <RiMapPin2Line />
                  </span>
                  {items && items.address}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="property-details-slider-section pt-4">
          <div className="container">
            <div className="row slider-row">
              <div className="col-sm-12 col-xl-8">
                <div className="property-details-slider-main-div">
                  <img
                    src={
                      items &&
                      items.property_images &&
                      items.property_images.length &&
                      (mainImage || items.property_images[0].image)
                    }
                    alt="Arrow Icon"
                  />
                  <SliderComponent items={items} setMainImage={setMainImage} />
                </div>
              </div>

              <div className="col-sm-12 col-xl-4">
                <div className="property-details-slider-form-div">
                  <form id="contact" onSubmit={handleSubmit}>
                    <h3>Enquiry Form</h3>
                    <fieldset>
                      <input
                        placeholder="Name"
                        type="text"
                        tabIndex={1}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </fieldset>
                    <fieldset>
                      <input
                        placeholder="Email"
                        type="email"
                        tabIndex={2}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </fieldset>
                    <fieldset>
                      <input
                        placeholder="Phone No."
                        type="number"
                        tabIndex={3}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        maxLength={10}
                        required
                      />
                    </fieldset>

                    <fieldset>
                      <textarea
                        placeholder="Message"
                        tabIndex={5}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                      />
                    </fieldset>
                    <fieldset>
                      <button
                        name="submit"
                        type="submit"
                        id="contact-submit"
                        data-submit="...Sending"
                      >
                        Book Property
                      </button>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="property-details-overview-section py-4">
          <div className="container">
            <div className="row slider-row">
              <div className="col-sm-12 col-xl-8">
                <div className="property-details-overview">
                  <h3>Overview</h3>
                  <div className="property-details-overview-btn">
                    {items && (
                      <p>
                        <span>
                          <MdOutlineBed />
                        </span>
                        {items.badroom}
                      </p>
                    )}
                    {items && (
                      <p>
                        <span>
                          <MdOutlineBathtub />
                        </span>
                        {items.bathroom}
                      </p>
                    )}
                    {items && (
                      <p>
                        <span>
                          <FaRegCopy />
                        </span>
                        {items.area_sqft} Sqft
                      </p>
                    )}

                    {items && (
                      <p>
                        <span>
                          <BsCarFront />
                        </span>
                        {items.garage_spaces} Parking
                      </p>
                    )}
                  </div>
                </div>
                {items && items.description && (
                  <div className="property-details-overview description my-4 ">
                    <h3>Description</h3>
                    <p dangerouslySetInnerHTML={{ __html: items.description }}></p>
                  </div>
                )}
                <div className="property-details-address my-4 ">
                  <h3>Property Address</h3>
                  <div className="property-details-address-details">
                    {items && items.address && <p>Address : {items.address}</p>}
                    {items && items.city && <p>City : {items.city}</p>}
                    {items && items.state && <p>State : {items.state}</p>}
                    {items && items.country && <p>Country : {items.country}</p>}
                    {items && items.pincode && <p>Pincode : {items.pincode}</p>}
                  </div>
                </div>
                <div className="property-details-ameneties my-4 ">
                  <h3>Amenities</h3>
                  <div className="property-detail-ameneties-main">
                    {items &&
                      items?.amenities?.map((data, index) => (
                        <div key={index} className="property-detail-ameneties">
                          <p>
                            <span>*</span>
                            {data}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-xl-4">
                <div className="property-details-slider-map-div">
                  <h3>Maps</h3>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d23636933.18422941!2d-20.123043607120856!3d43.68211601401104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46ed8886cfadda85%3A0x72ef99e6b3fcf079!2sEurope!5e0!3m2!1sen!2sin!4v1723115314604!5m2!1sen!2sin"
                    width="100%"
                    height="450"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                  {/* <img
                    src="/images/location.png"
                    alt="map"
                    className="map-image"
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="property-details-related-property pt-3">
          <div className="container">
            <h3 className="related-property-heading">Related Property</h3>
            <div className="row list-row pb-3">
              {related &&
                related?.map((item, i) => {
                  return (
                    <div key={i} className="col-sm-12 col-md-6 col-xl-4 mt-3" onClick={() =>
                      navigate(`/property-details/${item.slug}-${item.id}`)
                    }>
                      <div className="property-list-box related-box">
                        <div
                          className="property-list-box-img"
                          style={{ backgroundImage: `url(${item.image})` }}
                        >
                          <div className="listing-box-img-btn">
                            {item.Type && (
                              <button className="sale-btn">
                                For {item.Type}
                              </button>
                            )}
                            <button className="sale-btn featured">
                              Featured
                            </button>
                          </div>
                        </div>
                        <div
                          className="property_listing_title"
                          onClick={() => navigate("/property-details")}
                        >
                          <h3 className="truncate-title">{item.title}</h3>
                          <p>
                            <span>
                              <FiMapPin />
                            </span>
                            {item.address}
                          </p>
                        </div>
                        <div className="property-list-details">
                          <p>
                            <span>
                              <MdOutlineBed />
                            </span>
                            {item.badroom} Beds
                          </p>
                          <p>
                            <span>
                              <MdOutlineBathtub />
                            </span>
                            {item.bathroom} Baths
                          </p>
                          <p>
                            <span>
                              <FaRegCopy />
                            </span>
                            {item.area_sqft} Sqft
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </section>
        {/* <Pagination /> */}
        <Faq />
        <Footer />
      </div>
    </>
  );
};

export default PropertyDetails;
